
import type { ElementType, ReactNode } from 'react';
import { cx } from '@client/shared/lib/cx.ts';
import styles from './layout.module.css';

export interface ContainerProps {
  size?: 'narrow' | 'default' | 'wide';
  as?: ElementType;
  className?: string;
  children?: ReactNode;
}

export function Container({ size = 'default', as: As = 'div', className, children }: ContainerProps) {
  return (
    <As data-size={size} className={cx(styles.container, className)}>
      {children}
    </As>
  );
}
